<template>
  <div class="SECTION p-t-6">
    <div v-if="isLoading"/>
    <div v-else>
      <div class="p-6 m-b-6 bg-gray20">
        <div class="h2 text-bold c-gray90 p-b-2">
          Pro Referral Resources
        </div>
        <div class="h6 c-gray90">
          Click Image to View and Print.
        </div>
      </div>
      <div>
        <div class="EVEN m-b-6">
          <resource-list :title=$options.ASSOCIATE :resources="associateList"/>
        </div>
        <div class="EVEN m-b-6">
          <resource-list :title="$options.CARD" :resources="cardList"/>
        </div>
        <div class="EVEN">
          <resource-list :title="$options.PRO" :resources="proList"/>
        </div>
      </div>
      <div v-if="hasError" class="d-flex fd-column">
        <div class="p-6 TEXT-ERROR">
          {{ errorStatement }}
        </div>
        <img
            v-if="hasContentError"
            class="IMAGE"
            src="./assets/emptystate_screwdriver.svg"
        />
        <img
            v-else
            class="IMAGE"
            src="./assets/emptystate_wrench.svg"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import ResourceList from './components/ResourceList';

export default {
  PRO: 'For the Pro',
  ASSOCIATE: 'For Associate',
  CARD: 'Pro Referral - Get Guides',
  name: 'resources',
  components: {
    ResourceList,
  },
  data () {
    return {
      content: {},
      isLoading: false,
      hasContentError: false,
      isOpen: false,
      isModalOpen: false,
      currentImage: '',
      proList: [],
      associateList: [],
      cardList: [],
    };
  },
  computed: {
    resources () {
      if (this.content.items === undefined) {
        return [];
      }
      const resources = this.content.items.map((item => item));
      return [...resources].sort((a, b) => ((a.priority > b.priority) ? 1 : -1));
    },
    hasError () {
      this.updateHasContentError(this.content && Object.keys(this.content).length === 0);
      if (this.hasContentError) {
        return true;
      }
      return Object.prototype.hasOwnProperty.call(this.content, 'error');
    },
    errorStatement () {
      return 'Oops! We’re experiencing an issue. Check back later for Pro Referral resources for the pros and the Help Desk.';
    },
  },
  watch: {
    hasError: {
      handler (newVal) {
        if (newVal) {
          if (!this.hasContentError) {
            this.$events.$emit(
              this.$events.TESTIMONIAL_ERROR,
              { storeId: this.$route.params.storeId }
            );
          }
        }
      },
      immediate: true,
    },
  },
  mounted () {
    this.getResources();
  },
  methods: {
    onClick () {
      if (this.isOpen) {
        this.isVisible = false;
        setTimeout(() => {
          this.isOpen = false;
        }, 400);
      } else {
        this.isOpen = true;
        setTimeout(() => {
          this.isVisible = true;
        }, 300);
      }
    },
    openImageModal (url) {
      this.currentImage = url;
      this.isModalOpen = true;
    },
    close () {
      this.isModalOpen = false;
      this.currentImage = '';
    },
    updateHasContentError (isTrue) {
      this.hasContentError = isTrue;
    },
    contentError () {
      this.$events.$emit(
        this.$events.TESTIMONIAL_CONTENT_ERROR,
        { storeId: this.$route.params.storeId }
      );
      this.hasContentError = true;
    },
    async getResources () {
      this.isLoading = true;
      await axios.get('/api/contentful/resources')
        .then(({ data }) => {
          this.content = data || {};
        });
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
      this.proList = this.content.items
        .filter((item => item.listName === this.$options.PRO))
        .sort((a, b) => ((a.priority > b.priority) ? 1 : -1));
      this.associateList = this.content.items
        .filter((item => item.listName === this.$options.ASSOCIATE))
        .sort((a, b) => ((a.priority > b.priority) ? 1 : -1));
      this.cardList = this.content.items
        .filter((item => item.listName === this.$options.CARD))
        .sort((a, b) => ((a.priority > b.priority) ? 1 : -1));
    },
  },
};

</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.SECTION {
  max-width: $unit * 118;
}
.TEXT-ERROR{
  font-size: 18px;
  @include tablet{
    width: $unit * 90;
  }
}
.IMAGE {
    max-width: 270px;
    padding-right: 2 * $unit;
    align-self: auto;
   &:last-child {
     padding-right: 0px;
    }
    @include mobile-only (){
      max-width: 98px;
    }
    @include tablet-only (){
      max-width: 150px;
    }
}
.EVEN {
  background-color: $color-gray20;
}
</style>
